import { render } from "./WhatsIcon.vue?vue&type=template&id=b954cfec&scoped=true"
import script from "./WhatsIcon.vue?vue&type=script&lang=js"
export * from "./WhatsIcon.vue?vue&type=script&lang=js"

import "./WhatsIcon.vue?vue&type=style&index=0&id=b954cfec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b954cfec"]])

export default __exports__